<template>
    <div>

      <h3>{{ $t('ct-blog-settings')}} </h3>

      <div class="form-group">
        <label for=""> {{ $t('ct-blog-restore-social-colors')}}  </label>
        <button @click="restoreColors" class="btn btn-default">Restore</button>
      </div>

      <div class="form-group">
        <label @click="getAuthors" for=""> {{ $t('ct-blog-select-author')}}  </label>
        <select v-model="selectedAuthorID" id="" class="form-control">
          <option v-for="author in authors" :key="author.id" :value="author.cryptID"> {{ author.name }} </option>
        </select>
      </div>

      <div class="float-right">
        <button
          slot="button"
          class="btn btn-outline-info"
          @click="close"
        >{{ $t('ct-cancel') }}
        </button>
        <button
          slot="button"
          class="btn btn-outline-success focus"
          @click="save"
        ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </div>
    </div>
</template>

<script>
import { getChilds } from '../../../../../../js/services/editor/blog.js';

export default {
  name: 'CardAuthorSettings',
  props: ['config'],
  data() {
    return {
      authors: [],
      selectedAuthorID: ''
    };
  },
  methods: {
    getAuthors() {
      getChilds('?type=authors')
        .then(({data}) => {
          this.authors = data;
        });
      this.selectedAuthorID = this.config.authorID;
    },
    close() {
      this.$emit('close');
    },
    restoreColors() {
      let obj = { type: 'colors', value: 'restore' };
      this.$emit('save', obj);
      this.$emit('close');
    },
    save() {
      let obj = { type: 'author', value: this.selectedAuthorID };
      this.$emit('save', obj);
      this.$emit('close');
    }
  },
  mounted() {
    this.getAuthors();
  },
  watch: {
    config() {
      getChilds('?type=authors')
        .then(({data}) => {
          this.authors = data;
        });
      this.selectedAuthorID = this.config.authorID;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Settings/content/CardAuthorSettings.vue